var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-layout"}},[_c('el-header',{attrs:{"id":"topHeader","height":"56px"}},[_c('Header')],1),_c('div',{attrs:{"id":"bodyWrap"}},[_c('el-aside',{attrs:{"id":"leftNav","width":"280px"}},[_c('Nav')],1),_c('el-main',{attrs:{"id":"main"}},[_c('router-view',{key:_vm.key})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }